var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 75,
    viewBox: "0 0 77 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7122 63.6969H53.6353V46.35C53.6353 42.2134 53.5615 36.8884 47.8742 36.8884C42.1049 36.8884 41.2222 41.3953 41.2222 46.0488V63.6957H30.1453V28.0234H40.7792V32.8984H40.928C41.9922 31.0789 43.53 29.582 45.3776 28.5673C47.2252 27.5525 49.3135 27.058 51.4199 27.1361C62.6468 27.1361 64.7168 34.5207 64.7168 44.1277L64.7122 63.6969ZM17.6468 23.1473C16.3755 23.1475 15.1326 22.7708 14.0755 22.0646C13.0182 21.3585 12.1941 20.3547 11.7074 19.1802C11.2206 18.0057 11.0931 16.7133 11.3409 15.4663C11.5887 14.2194 12.2007 13.0738 13.0995 12.1747C13.9984 11.2756 15.1436 10.6631 16.3905 10.4149C17.6374 10.1666 18.9299 10.2937 20.1045 10.78C21.2793 11.2663 22.2833 12.0901 22.9898 13.147C23.6963 14.2039 24.0735 15.4467 24.0738 16.718C24.0739 17.5622 23.9078 18.3982 23.5849 19.178C23.262 19.958 22.7886 20.6667 22.1918 21.2637C21.5951 21.8607 20.8865 22.3344 20.1067 22.6576C19.3268 22.9808 18.491 23.1472 17.6468 23.1473ZM23.1853 63.6969H12.0968V28.0234H23.1853V63.6969ZM70.2345 0.00460313H6.5307C5.08481 -0.0117138 3.69157 0.546674 2.65716 1.55706C1.62276 2.56745 1.03181 3.94719 1.01416 5.39306V69.3611C1.0312 70.8077 1.62179 72.1884 2.65616 73.1999C3.69053 74.2113 5.08409 74.7708 6.5307 74.7554H70.2345C71.684 74.7736 73.0814 74.2157 74.1199 73.2042C75.1583 72.1929 75.7529 70.8106 75.773 69.3611V5.38844C75.7523 3.9397 75.1574 2.55841 74.119 1.54804C73.0804 0.537674 71.6833 -0.0191196 70.2345 -1.22629e-05V0.00460313Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.1538,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider3);
export default __webpack_public_path__ + "static/media/slider-3.95b5e853d471f85a00f164d2ad82b2a6.svg";
export { ForwardRef as ReactComponent };